import { setSlotFolderPickAction, updateSlotFileSetAction } from 'editor/src/store/app/slice';
import setCollectionFolderOperation from 'editor/src/store/collections/operations/setCollectionFolderOperation';
import { CollectionFolder } from 'editor/src/store/collections/types';
import type { AsyncThunk } from 'editor/src/store/hooks';

/** The folder the host's library returned goes into the picture set it was opened for. */
const pickSlotFolderOperation =
  (folder: CollectionFolder, selectedAssetIds?: string[]): AsyncThunk =>
  async (dispatch, getState) => {
    const builder = getState().app.slotLayoutBuilder;
    const pick = builder?.folderPick;
    if (!builder || !pick) {
      return;
    }
    // Taken before the folder's assets are measured: a second picker opened meanwhile must
    // find no pick, or its folder would be read as this one's answer.
    dispatch(setSlotFolderPickAction(undefined));
    await dispatch(setCollectionFolderOperation(folder));

    dispatch(
      updateSlotFileSetAction({
        id: pick.fileSetId,
        patch: {
          folders: {
            [pick.columns]: { folderId: folder.id, assetIds: selectedAssetIds?.length ? selectedAssetIds : undefined },
          },
        },
      }),
    );
  };

export default pickSlotFolderOperation;
